<template>
  <div v-if="formattedDuration" class="flex gap-1 items-center" data-testid="item-duration">
    <Icon name="general.clock" size="sm" />
    <span>{{ formattedDuration }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { Icon } from '@/storybook/icon';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

const { item } = storeToRefs(useViewerItemStore());

const formattedDuration = computed(() => {
  const duration = item.value?.attributes?.info?.formattedDuration?.trim();

  if (!duration || duration === '00:00' || duration === '00:00:00') {
    return undefined;
  }

  return duration;
});
</script>
